export default __webpack_public_path__ + "static/media/misc-drawerA-1024w.ebd4fba5.avif";